import { Component, HostListener, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Vehicle } from '@app-model/vehicle';
import { AlternativeBidRequest } from '@app-services/dealer.service';

@Component({
  selector: 'app-dialog-confirm-send-alternative-bid',
  templateUrl: './dialog-confirm-send-alternative-bid.component.html',
  styleUrls: ['./dialog-confirm-send-alternative-bid.component.scss']
})
export class DialogConfirmSendAlternativeBidComponent {

  vehicle: Vehicle;
  alternativeBid: AlternativeBidRequest;
  comparisonLabel = '';
  comparisonValue = 0;

  constructor(
    private dialogRef: MatDialogRef<DialogConfirmSendAlternativeBidComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {
       vehicle: Vehicle,
       alternativeBid: AlternativeBidRequest,
       minimumBidValue?: number
      },
  ) {
    this.vehicle = data?.vehicle;
    this.alternativeBid = data?.alternativeBid;
    this.setComparisonFields(data?.minimumBidValue);
  }

  private setComparisonFields(minimumBidValue?: number): void {
    const proposedValue = this.alternativeBid?.value || 0;
    const highestAlternative = this.vehicle?.highestAlternativeBidValue;
    const shouldShowHighestAlternative =
      !minimumBidValue &&
      !!highestAlternative &&
      proposedValue < highestAlternative;

    if (minimumBidValue) {
      this.comparisonValue = minimumBidValue;
      this.comparisonLabel = 'Oferta mínima';
      return;
    }

    if (shouldShowHighestAlternative) {
      this.comparisonValue = highestAlternative;
      this.comparisonLabel = 'Maior oferta personalizada';
      return;
    }

    this.comparisonValue = this.vehicle?.currentPrice;
    this.comparisonLabel = 'Oferta mínima';
  }

  @HostListener('window:keyup.esc')
  onNoClick(): void {
    this.dialogRef.close();
  }

  onClickConfirm(): void {
    this.dialogRef.close({ confirm: true });
  }
}


